export const Public_Routes = {
    LOGIN: '/login',
};

export const Private_Routes = {
    HOME: '/',
    EMPLOYEE_PAGE: '/employees',
    CREATE_EMPLOYEE_PAGE: '/employees/create-employee',
    UPDATE_EMPLOYEE_PAGE: '/employees/update-employee/:id',

    CUSTOMER_PAGE: '/customers',
    CREATE_CUSTOMER: '/customers/create-customer',
    UPDATE_CUSTOMER: '/customers/update-customer/:id',

    PROJECT_PAGE: '/projects',
    CREATE_PROJECT: '/projects/create-project',
    UPDATE_PROJECT: '/projects/update-project/:id',
    OVERVIEW_PROJECT: '/projects/projects-list/:id',

    CONTACTS_PAGE: '/customers/contacts/contacts-list/:id',
    CREATE_CONTACT: '/customers/contacts/create-contact',
    UPDATE_CONTACT: '/customers/contacts/update-contact/:id',

    PROJECT_CHECKPOINTS_PAGE: '/project-checkpoints',
    CREATE_PROJECT_CHECKPOINTS_PAGE: '/project-checkpoints/create/:projectId',
    UPDATE_TASKS_CHECKPOINTS_PAGE:
        '/project-checkpoints/tasks-by-project-checkpoints/:id',

    PROJECT_STATUS_PAGE: '/project-status',
    CREATE_PROJECT_STATUS: '/project-status/create-project-status',
    UPDATE_PROJECT_STATUS: '/project-status/update-project-status/:id',

    PROJECT_MILESTONE_PAGE: '/project-milestone',
    CREATE_PROJECT_MILESTONE: '/project-milestone/create-project-milestone',
    UPDATE_PROJECT_MILESTONE: '/project-milestone/update-project-milestone/:id',

    PROFILE: '/account/profile',
};
